module.exports = __webpack_public_path__ + "img/vector-circle.c5aaa060.svg";